package com.qrkontaq.core.logger

import com.qrkontaq.core.config.AppConfig
import com.qrkontaq.core.config.Environment

class Logger private constructor(private val name: String) {
    companion object {
        fun getLogger(name: String): Logger = Logger(name)
    }

    private val isDevelopment = AppConfig.environment == Environment.DEVELOPMENT

    fun trace(message: String) {
        if (isDevelopment) {
            console.log("[$name] TRACE: $message")
        }
    }

    fun trace(message: String, throwable: Throwable) {
        if (isDevelopment) {
            console.log("[$name] TRACE: $message", throwable)
        }
    }

    fun debug(message: String) {
        if (isDevelopment) {
            console.log("[$name] DEBUG: $message")
        }
    }

    fun debug(message: String, throwable: Throwable) {
        if (isDevelopment) {
            console.log("[$name] DEBUG: $message", throwable)
        }
    }

    fun info(message: String) {
        if (isDevelopment) {
            console.info("[$name] INFO: $message")
        }
    }

    fun info(message: String, throwable: Throwable) {
        if (isDevelopment) {
            console.info("[$name] INFO: $message", throwable)
        }
    }

    fun warn(message: String) {

        console.warn("[$name] WARN: $message")
    }

    fun warn(message: String, throwable: Throwable) {

        console.warn("[$name] WARN: $message", throwable)
    }

    fun error(message: String) {

        console.error("[$name] ERROR: $message")
    }

    fun error(message: String, throwable: Throwable) {

        console.error("[$name] ERROR: $message", throwable)
    }
}

inline fun <reified T> getLogger(): Logger = Logger.getLogger(T::class.simpleName ?: "Unknown")
